module.exports = __webpack_public_path__ + "static/media/image_part_005.40ceddb6.jpg";